import React from "react";
import { CountUp } from "./Motion";
import { Sparkle, Squiggle } from "./Decorations";

const STATS = [
    { value: 2000, suffix: "+", label: "registered news portals", color: "#FF5B3E" },
    { value: 300, suffix: "M+", label: "Bengali speakers worldwide", color: "#3D5BFF" },
    { value: 0.02, prefix: "$", decimals: 2, label: "cost per article generated", color: "#2EE8B5" },
    { value: 0, label: "local competitors. Yet.", color: "#FFD23F" },
];

export const Stats = () => {
    return (
        <section className="relative py-20 lg:py-28 bg-cream-200 border-y border-cream-300 overflow-hidden">
            <Squiggle color="#FF4FA3" className="absolute top-8 right-[8%] w-24 animate-float-slow"/>
            <Sparkle color="#FFD23F" className="absolute bottom-10 left-[12%] w-9 h-9 animate-float-fast"/>

            <div className="relative mx-auto max-w-[1240px] px-5 sm:px-8">
                <p className="text-center text-[11px] uppercase tracking-[0.22em] font-semibold text-coral mb-12">By the numbers</p>
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8">
                    {STATS.map((s, i) => (
                        <div key={i} data-testid={`stat-${i}`} className="text-center">
                            <div className="font-display font-bold text-[56px] sm:text-[72px] lg:text-[88px] leading-none text-ink">
                                <CountUp to={s.value} prefix={s.prefix} suffix={s.suffix} decimals={s.decimals || 0}/>
                            </div>
                            <div className="mt-3 text-[13px] sm:text-[14px] text-ink-muted max-w-[180px] mx-auto leading-snug">
                                {s.label}
                            </div>
                            <div className="mt-3 mx-auto w-10 h-1 rounded-full" style={{ background: s.color }}/>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
